import React from 'react';

/**
 * Thin sprocket strips along the top and bottom of the viewport that frame the
 * page like a length of film.
 */
export function FilmEdges() {
  return <div aria-hidden="true" className="pointer-events-none" data-id="element-24" data-mp="qaw7jysv5ck0">
      <div className="fixed inset-x-0 top-0 z-50 h-3 bg-black" data-id="element-25" data-mp="lgij6gcmc5ou">
        <div className="sprocket-strip mx-8 h-full opacity-90" data-id="element-26" data-mp="gj8mqgqtatri" />
      </div>
      <div className="fixed inset-x-0 bottom-0 z-50 h-3 bg-black" data-id="element-27" data-mp="ggw4s3l20jeg">
        <div className="sprocket-strip mx-8 h-full opacity-90" data-id="element-28" data-mp="bl73nvtdyug1" />
      </div>
    </div>;
}